import React from "react";
import { Stack, Text, StackProps, SimpleGrid } from "@chakra-ui/core";
import Button from "@pency/components/controls/Button";
import Link from "@pency/components/controls/Link";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Heading from "~/ui/display/Heading";
import { getLocale } from "~/i18n/selectors";
import { useTranslation } from "~/i18n/hooks";
import styled from '@emotion/styled'

const StyledGrid = styled(SimpleGrid)`
  .image-banner {
    @media (max-width: 767px) {
      display: none;
    }
  }
`

const HomeHero: React.FC<StackProps> = () => {
  const locale = getLocale();
  const t = useTranslation();

  return (
    <StyledGrid
      columns={{ base: 1, md: 2 }}
      p={{ md: 20, base: 5 }}
      position={"relative"}
      mt={{ md: 16, base: 10 }}
      mb={{ md: 16, base: "1rem" }}
      overflow='hidden'   
    >
      <Stack
        shouldWrapChildren
        flex={1}
        maxWidth={{ base: "100%", md: '80%' }}
        paddingBottom={{ base: 6 }}
        spacing={{ base: 0, md: 8 }}
      >
        <Stack spacing={6} position='relative' zIndex={10}>
          <Heading
            as="h1"
            fontSize={{ base: "4xl", md: "6xl" }}
            paddingX={{ base: 4, md: 0 }}
            textAlign={{ base: "center", md: "left" }}
            color={"green.400"}
          >
            {t("home.hero.title")}
          </Heading>
          <Text
            as="h3"
            fontSize={{ base: "lg", md: "xl" }}
            textAlign={{ base: "center", md: "left" }}
          >
            {t("home.hero.subtitle")}
          </Text>
        </Stack>
        <Stack
          isInline
          display={{ base: "none", md: "inherit" }}
          justifyContent="center"
          spacing={4}
          textAlign={{ base: "center", md: "left" }}
        >
          <Link href={`${process.env.SIGNUP_URL}/${locale}`}>
            <Button
              _hover={{ boxShadow: "lg" }}
              size="lg"
              backgroundColor="green.400"
              color={"white"}
            >
              {t("home.hero.actionPrimary")}
            </Button>
          </Link>
        </Stack>
      </Stack>
        <LazyLoadImage 
          className='image-banner' 
          width="100%" 
          wrapperProps={{style: {
            transform: 'scale(190%)',
            position: 'relative',
            right: '5rem',
            display: 'flex',
            alignItems: "center",
            justifyContent: "center",
            bottom: '1rem'
          }}}  
          alt={t("home.hero.imgAlt")}    
          effect="blur"
          src={"/assets/hero-banner.png"}
          />
    </StyledGrid>
  );
};

export default HomeHero;
